<template>
  <div class="cap">
    <span
      v-if="priceDiffs"
      :class="`${priceDiffs > 0 ? 'green' : 'red'}`"
    >
      {{ priceDiffs > 0 ? '+' : '' }}{{ priceDiffs }}%
    </span>
  </div>
</template>

<script lang="ts" setup>
import type { ItemsPriceDiffs } from '~/graphql/generated/schema-types';

defineProps<{
  priceDiffs: ItemsPriceDiffs['price_difference']
}>();
</script>
